import React, { Fragment, useContext, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";


const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } = useContext(
    ThemeContext
  );
  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            <svg className="logo-abbr" width="32" height="32" viewBox="60.00 104.42 79.66 79.66" xmlns="http://www.w3.org/2000/svg">
              <g transform="rotate(18 -506.669 274.413)">
                <rect width="18" height="60" y="-60" fill="#bbf7d0" rx="4" />
                <rect width="18" height="60" y="-60" fill="none" stroke="#86efac" rx="4" />
                <rect width="14" height="1.5" x="2" y="-47" fill="#16a34a" rx="1" />
                <rect width="10" height="1" x="2" y="-44" fill="#16a34a" rx="1" />
                <rect width="12" height="1" x="2" y="-41" fill="#16a34a" rx="1" />
              </g>
              <g transform="rotate(18 -495.669 343.864)">
                <rect width="18" height="60" y="-60" fill="#e9d5ff" rx="4" />
                <rect width="18" height="60" y="-60" fill="none" stroke="#d8b4fe" rx="4" />
                <rect width="14" height="1.5" x="2" y="-47" fill="#9333ea" rx="1" />
                <rect width="8" height="1" x="2" y="-44" fill="#9333ea" rx="1" />
                <rect width="11" height="1" x="2" y="-41" fill="#9333ea" rx="1" />
              </g>
              <g transform="rotate(18 -484.669 413.315)">
                <rect width="18" height="60" y="-60" fill="#bfdbfe" rx="4" />
                <rect width="18" height="60" y="-60" fill="none" stroke="#93c5fd" rx="4" />
                <rect width="14" height="1.5" x="2" y="-47" fill="#1d4ed8" rx="1" />
                <rect width="9" height="1" x="2" y="-44" fill="#1d4ed8" rx="1" />
                <rect width="12" height="1" x="2" y="-41" fill="#1d4ed8" rx="1" />
              </g>
            </svg>
            <div className="brand-title">
              <h2 className="">Ledger<span>Loop</span></h2>

            </div>
          </Fragment>
        ) : (
          <Fragment>
            <svg className="logo-abbr" width="32" height="32" viewBox="60.00 104.42 79.66 79.66" xmlns="http://www.w3.org/2000/svg">
              <g transform="rotate(18 -506.669 274.413)">
                <rect width="18" height="60" y="-60" fill="#bbf7d0" rx="4" />
                <rect width="18" height="60" y="-60" fill="none" stroke="#86efac" rx="4" />
                <rect width="14" height="1.5" x="2" y="-47" fill="#16a34a" rx="1" />
                <rect width="10" height="1" x="2" y="-44" fill="#16a34a" rx="1" />
                <rect width="12" height="1" x="2" y="-41" fill="#16a34a" rx="1" />
              </g>
              <g transform="rotate(18 -495.669 343.864)">
                <rect width="18" height="60" y="-60" fill="#e9d5ff" rx="4" />
                <rect width="18" height="60" y="-60" fill="none" stroke="#d8b4fe" rx="4" />
                <rect width="14" height="1.5" x="2" y="-47" fill="#9333ea" rx="1" />
                <rect width="8" height="1" x="2" y="-44" fill="#9333ea" rx="1" />
                <rect width="11" height="1" x="2" y="-41" fill="#9333ea" rx="1" />
              </g>
              <g transform="rotate(18 -484.669 413.315)">
                <rect width="18" height="60" y="-60" fill="#bfdbfe" rx="4" />
                <rect width="18" height="60" y="-60" fill="none" stroke="#93c5fd" rx="4" />
                <rect width="14" height="1.5" x="2" y="-47" fill="#1d4ed8" rx="1" />
                <rect width="9" height="1" x="2" y="-44" fill="#1d4ed8" rx="1" />
                <rect width="12" height="1" x="2" y="-41" fill="#1d4ed8" rx="1" />
              </g>
            </svg>
            <div className="brand-title">
              <h2 className="">Ledger<span>Loop</span></h2>
            </div>
          </Fragment>
        )}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          openMenuToggle();
        }}>
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
